<template>
  <section class="p-2">
    <v-card-title class="pt-0 mt-2">
      <v-btn depressed @click="downloadExcelsheet" color="primary" small
        ><v-icon small>mdi-file-excel-outline</v-icon>Export
      </v-btn>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        placeholder="Search"
        dense
        class="rounded"
        label="Type here to filter the table data."
        hide-details
        single-line
      ></v-text-field
    ></v-card-title>
    <v-data-table
      fixed-header
      height="55vh"
      :headers="headers"
      dense
      :items-per-page="10"
      :items="historyLIst"
      no-data-text="Please select the criteria to view records"
      :search="search"
    >
    </v-data-table>
    <OverlayPageVue :showOverlay="loaderOverlay" />
  </section>
</template>

<script>
import setupService from "@/services/SetupService/setupService.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
export default {
  name: "Sanction List History",
  data() {
    return {
      valid: true,
      search: "",
      loaderOverlay: false,
      historyLIst: [],
      headers: [
        {
          text: "Date",
          value: "uploaded_date",
        },
        {
          text: "File Name",
          value: "document_name",
        },
        {
          text: "Total",
          value: "total_records",
        },
        {
          text: "Success",
          value: "no_of_success",
        },
        {
          text: "Failure",
          value: "no_of_failure",
        },
      ],
    };
  },
  components: {
    OverlayPageVue,
  },
  mounted() {
    this.getallListhistory("BLACK");
  },

  computed: {},
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.historyLIst) {
        this.exportToExcel(this.headers, this.historyLIst, "history_List");
      }
    },
    async getallListhistory(BLACK) {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getSanctionhistory(BLACK);
        if (response.data.status_code === 200) {
          this.historyLIst = response.data.data[0].reverse();
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.historyLIst = [];
        //   this.returnNewToken();
        //   this.getallListhistory();
        //   this.stoploader();
        // }
        else {
          this.historyLIst == [];
          this.stoploader();
        }
      } catch (error) {
        this.historyLIst = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.custome-profile {
  background-color: #f3f3f3;
}
.btn_active {
  background-color: $primary !important;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 8px 20px, rgba(0, 0, 0, 0.13) 0px 6px 6px !important;
}
.border {
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px !important;
}
.v-text-field__details {
  display: none !important;
}
.v-sheet--offset {
  top: -14px;
  width: 250px;
  height: 30px;
  position: relative;
  border-radius: 5px;
  background-color: rgb(233, 227, 227) !important;
}
.v-sheet--offset1 {
  top: -20px;
  position: relative;
  border-radius: 10px;
  background-color: rgb(131, 24, 24) !important;
}
.a_text {
  color: green;
}
.a_text:hover {
  border-bottom: 1px solid green;
}
.failure_text {
  color: red;
}
.failure_text:hover {
  border-bottom: 1px solid red;
}
.instruction {
  font-size: 12px;
}
</style>
